<template>
  <div class="Privacy">
    <!-- <div class="PrivacyComContainer crumbs">
      <router-link to="/">Home</router-link> &gt; Privacy Policy
    </div> -->
    <div class="PrivacyComContainer privacy-wrap">
      <div class="policy-con-box">
        <h3>Privacy Policy</h3>
        <p>
          At China Radio International (CRI) we take the protection of personal
          information very seriously. We aim to make our services to be safe and
          enjoyable for everyone. On this page we will detail the kind of
          information we might collect about you, how we might use it.
        </p>
        <p>Our policy in full:</p>
        <h4>1. Introduction &amp; General Terms</h4>
        <p>
          This Privacy Policy relates to our use of any personal information we
          may collect from you via the following online services:
        </p>
        <p>Any CRI website that links to this Privacy Policy;</p>
        <p>Social media or official CRI content on other websites;</p>
        <p>Mobile Applications (apps);</p>
        <p>
          It also relates to our use of any personal information you provide to
          us by phone, such as SMS, email, in letters and through other
          correspondence and in person.
        </p>
        <p>
          In order to provide you with a comprehensive range of services, CRI
          may sometimes need to collect information about you.
        </p>
        <p>This Privacy Policy explains the following:</p>
        <p>What information CRI may collect about you;</p>
        <p>How CRI will use information we collect about you;</p>
        <p>When CRI may use your details to contact you;</p>
        <p>Whether CRI will disclose your details to anyone else;</p>
        <p>
          Your choices regarding the personal information you provide to us;
        </p>
        <p>
          The use of cookies on CRI websites and how you can reject cookies.
        </p>
        <p>
          CRI is committed to safeguarding your personal information. Whenever
          you provide such information, we are legally obliged to use your
          information in line with all laws concerning the protection of
          personal information.
        </p>
        <p>
          CRI websites contain hyperlinks to websites owned and operated by
          third parties. These third party websites have their own privacy
          policies, and are also likely to use cookies, and we therefore urge
          you to review them. They will govern the use of personal information
          you submit, which may also be collected by cookies whilst visiting
          these websites. We do not accept any responsibility or liability for
          the privacy practices of such third party websites and your use of
          such websites is at your own risk.
        </p>
        <h4>2. What is China Radio International (CRI)?</h4>
        <p>
          China Radio International was founded on December 3, 1941. CRI aims to
          introduce China to the rest of the world, introduce the world to
          China, report global affairs to the world, and promote understanding
          and friendship between the people of China and those from other
          countries. CRI is China's only state-level radio and television media
          organization specializing in international communications. CRI is
          headquartered in Beijing, China.
        </p>
        <h4>3. What information will CRI collect?</h4>
        <p>
          When you participate in, access or sign up to any of CRI's services,
          activities or online content, such as newsletters, competitions, web
          and mobile notifications, telephone or text message CRI, or create an
          account at CRI's news app we may receive personal information about
          you. This can consists of information such as your name, email
          address, as well as information collected about your use of CRI
          services.
        </p>
        <p>
          Please note that sometimes we will require you to provide additional
          personal information, and sometimes sensitive personal information
          (e.g. if you're sending us a story or a group of pictures, we may need
          to know your postal code, telephone number and your address). When we
          do this we will provide further information as to why we are
          collecting your information and how we will use it.
        </p>
        <p>
          Some of our services enable you to sign-in via a third-party service
          such as Facebook or Twitter. If you choose to sign-in via a third
          party app, you will be presented with a dialog box which will ask your
          permission to allow CRI to access your personal information (e.g. your
          full name, date of birth, email address and any other information you
          have made publicly accessible). Please note that any information that
          is not required by the particular service you have opted to use will
          not be retained by CRI.
        </p>
        <p>
          CRI also uses cookies and similar technologies and collects IP
          addresses and other information about devices from visitors to CRI
          websites, users of its mobile device, and through other CRI content
          online.
        </p>
        <h4>4. How will CRI use the information it collects?</h4>
        <p>
          CRI will use your personal information for a number of purposes
          including the following:
        </p>
        <p>
          To provide our services, activities or online content, to provide you
          with information about them and to deal with your requests and
          enquiries;
        </p>
        <p>
          for "service administration purposes", which means that CRI may
          contact you for reasons related to the service, activity or online
          content you have signed up for, (e.g. to provide you with password
          reminders, to notify you that a particular service, activity or online
          content has been suspended for maintenance, to notify you of updates
          to our Privacy Policy or Terms of Use);
        </p>
        <p>
          Where we provide personalized services, we may need to analyze the
          information you supply, as well as your activity on our services, so
          that we can offer you a more personalized service (e.g. If the first
          thing you look at every day on China Plus app is the video program
          about foreigners living in China, we may present this information or a
          link to it on your homepage). If you do not wish to receive this,
          please turn off notifications; to contact you about a submission you
          have made, including any content you provide;
        </p>
        <p>
          to use IP addresses and device identifiers to identify the location of
          users, to block disruptive use, to establish the number of visits from
          different countries so that we may improve the services offered by
          CRI;
        </p>
        <p>
          Where CRI proposes using your personal information for any other uses
          we will ensure that we notify you first. You will also be given the
          opportunity to withhold or withdraw your consent for the use of your
          personal information for purposes other than those listed above.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Privacy",
  data() {
    return {
      msg: "Privacy",
    };
  },
};
</script>


<style scoped lang="scss">
.Privacy {
  background: #f3f4f5;
}
.PrivacyComContainer {
  width: 1280px;
  margin: 0 auto;
}
.crumbs {
  // margin-top: 67px;
  padding: 17px 0 27px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #999;
  display: block;
  a {
    color: #999;
  }
}
.privacy-wrap {
  font-size: 16px;
  line-height: 1.8em;
  padding: 0px 0px 117px 0px;
  margin-top: 30px;
  .policy-con-box {
    h3 {
      font-size: 24px;
      color: #333;
    }
    p {
      margin-top: 20px;
      text-align: justify;
      color: black;
    }
    h4 {
      margin-top: 22px;
      font: 22px/28px "Arial";
      color: #01aef0;
    }
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 900px) {
  * {
    box-sizing: border-box;
  }
  .crumbs{
    display: none;
  }
  .Privacy {
    background: #fff;
  }
  .PrivacyComContainer {
    width: 100%;
  }
  //@at-root.privacy-wrap 
  .privacy-wrap {
    padding: 30px 2% 130px 2%;
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Privacy.vue